import React, { useState, useContext } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Rating,
  Box,
  Typography,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,

} from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { toast } from "react-hot-toast";
import axios from "axios";
import { UserContext } from "../../context/userContext/userContext";
import { useStyle } from "../../context/styleContext/styleContext";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const LoginRegisterModal = ({ isOpen, close, loginComplete, sku }) => {
  const { style } = useStyle();
  const { user, userEmail, userFirstName, userLastName } = useContext(UserContext);
  const [loginEmail, setLoginEmail] = useState();
  const [loginPassword, setLoginPassword] = useState();
  const [loginScreenVisible, setLoginScreenVisible] = useState(true);
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPassword1, setRegisterPassword1] = useState("");
  const { setUser, setUpdateFlag } = useContext(UserContext);
const [ showPassword, setShowPassword ] = useState(false);
const [ showRegisterPassword1, setShowRegisterPassword1 ] = useState(false);
const [ showRegisterPassword2, setShowRegisterPassword2 ] = useState(false);

  const closeFunction = () => {
    close();
  };

  const loginCompleteFunction = (userEmail) => {
    //console.log("function fired")
    console.log("login complete function", userEmail )
    loginComplete(userEmail);
  }
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPasswordR1 = () => setShowRegisterPassword1((show) => !show);
  const handleClickShowPasswordR2 = () => setShowRegisterPassword2((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const[data,setData] = useState({
    email: '',
    password: '',
    registerEmail:'',
    registerPassword1:'',
    registerPassword2:'',
})


const switchToRegisterScreen = async (e) => {setLoginScreenVisible(false)}
const switchToLoginScreen = async (e) => {setLoginScreenVisible(true) }

const registerUser = async (e) => {
    e.preventDefault();

    var okToSend = true;

    const {registerEmail, registerPassword1, registerPassword2, okToEmail } = data;
   
    const email = registerEmail;
    const emailLowerCase = registerEmail.toLowerCase();
    const password = registerPassword1;
    const password2 = registerPassword2;

    if (!email) {
      okToSend = false;
      toast.error("Error: You must enter your E-Mail address to create an account");
    }
    if(!emailLowerCase)
    {
      okToSend = false;
      toast.error("Error: You must enter your E-Mail address to create an account");
    }

    if (!password) {
      okToSend = false;
      toast.error("Error: Password cannot be blank");
    }

    if (!password2) {
      okToSend = false;
      toast.error("Error: Please enter your password again");
    }

    if (password !== password2) {
      okToSend = false;
      toast.error("Passwords do not match");
    }

    if (okToSend) {
      try {

        console.log("sending... ", email, "  " , password)

        const { data } = await axios.post('/register', { email, password, okToEmail });

        if (data.error) {
          toast.error(data.error);
        } else {
          setData({});

          const{data} = await axios.post('/login', {
            email, 
            password,
          });
          const userData = data;
          if(data.error){

            toast.error(data.error)
        }   else {            

            await setUser(userData);
            localStorage.setItem('token', data.token)
            toast.success(data.success)
            await setUpdateFlag()
            const userEmail = emailLowerCase
            console.log("user email test 1: ", userEmail)
            loginCompleteFunction(userEmail);
            //window.location.href = `/`
    }



          toast.success('Registration Successful. Welcome!');
         //window.location.href = `/`
        }

      } catch (error) {
        console.log(error);
      }
    }
  };



  const loginUser = async (e) => {
    e.preventDefault()
    
    const {email, password} = data

        // const email = loginEmail;
        // const password = loginPassword
        //console.log(data);

        try{            
            const{data} = await axios.post('/login', {
                email,
                password
            });

            const userData = data;
            if(data.error){
                //console.log('error!!!!!')
                toast.error(data.error)
            }   else {            
                localStorage.setItem('token', data.token)
                await setUser(userData)
                console.log(userData)
                const userEmail = data.user.email
                toast.success("Login successful, welcome!")
                console.log("email from function ", userEmail)
                loginCompleteFunction(userEmail);
              
              
                //window.location.href = `/`
        }
        }catch(error){

        }

  };

  return (
    <Dialog
      open={isOpen}
      onClose={closeFunction}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          backgroundColor: style.color1,
          borderRadius: 15,
          border: `1px solid ${style.color2}`,
        },
      }}
    >
      <DialogContent sx={{ padding: 3, color:style.color4 }}>


      {!loginScreenVisible && (

<Box sx={{ textAlign: "center" }}>
   <Typography sx={{ mb: 6, fontSize:'2em', color:style.color4 }}>Register For a Free Account</Typography>
   <TextField
       id="outlined-basic"
       label="Email"
       variant="outlined"
       value= {data.registerEmail}
       onChange={(e) => setData({...data, registerEmail: e.target.value})}
       size='small'
       fullWidth
       sx={{
           backgroundColor: style.color2,
           borderRadius:'4px',
           '& .MuiInputBase-input': {
           color: style.color4,  // Change the font color here
           fontSize: '16pt',  // Change the font size here
           boxShadow:5,
                                           
           },
           '& .MuiOutlinedInput-root': {
           '& fieldset': {
               borderColor: style.color1, // Change the border color if needed
               borderWidth:'2px'
           },
           '&:hover fieldset': {
               borderColor: style.color1, // Change the border color on hover if needed\
               borderWidth:'3px',                                                               
        
               
           },
           '&.Mui-focused fieldset': {
               borderColor: style.color1, // Change the border color when focused if needed
               borderWidth:'3px'
               
           },
           '&.Mui-disabled': {
               '& fieldset': {
               borderColor: style.color1, // Change the border color when disabled
               },
           },
           },
           '& .MuiInputLabel-root': {
           color: style.color3, // Change the label color here
           fontSize:'14pt',
           },
           '& .MuiInputLabel-root.Mui-focused': {
           color: style.color3, // Change the label color when focused here                                 
           },
           '& .MuiInputLabel-root.Mui-disabled': {
           color: style.color2, // Change the label color when disabled
           },
           '& .MuiInputBase-root.Mui-disabled': {
           '& input': {
               color: style.color3, // Change the input font color when disabled // so it works in safari
               WebkitTextFillColor: style.color4, // so it works on chrome
               fontSize:'14pt'
           },
           },
           '& .MuiOutlinedInput-input': { color: style.color4,
           '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset',
               WebkitTextFillColor: style.color4, color:style.color4
            }, }, 
       }}
       />



<FormControl sx={{
         backgroundColor: style.color2,
         flex: 1,
         width:'100%',
         size: 'small',
         margin: 'auto',
         boxShadow:5,
         mt:3,

         '& .MuiInputBase-input': {
           color: style.color3,
           fontSize: '14pt',
           size: 'small',
         },
         '& .MuiOutlinedInput-root': {
           '& fieldset': {
             borderColor: style.color1,
             borderWidth: '2px'
           },
           '&:hover fieldset': {
             borderColor: style.color2,
             borderWidth: '3px',
           },
           '&.Mui-focused fieldset': {
             borderColor: style.color2,
             borderWidth: '3px',
           },
           '&.Mui-disabled': {
             '& fieldset': {
               borderColor: style.color1,
             },
           },
         },
         '& .MuiInputLabel-root': {
           color: style.color3,
           fontSize: '14pt',
         },
         '& .MuiInputLabel-root.Mui-focused': {
           color: style.color3,
         },
         '& .MuiInputLabel-root.Mui-disabled': {
           color: style.color3,
         },
         '& .MuiInputBase-root.Mui-disabled': {
           '& input': {
             color: style.color3,
             WebkitTextFillColor: style.color1,
             fontSize: '14pt'
           },
         },
         '& .MuiOutlinedInput-input': {
           color: style.color4,
           '& input:-webkit-autofill': {
           WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
           WebkitTextFillColor: `${style.color4} !important`,
           color: `${style.color4} !important`,
           caretColor: `${style.color4} !important`,
       },
         },
       }} variant="outlined">
         <InputLabel size="small" htmlFor="outlined-adornment-password1">Password</InputLabel>
         <OutlinedInput
           id="outlined-adornment-password1"
           type={showRegisterPassword1 ? 'text' : 'password'}
           value={data.registerPassword1}
           size='small'
           onChange={(e) => setData({...data, registerPassword1: e.target.value})}
           sx={{
               '& input:-webkit-autofill': {
               WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
               WebkitTextFillColor: `${style.color4} !important`,
               color: `${style.color4} !important`,
               caretColor: `${style.color4} !important`,
               
           },
           }}
           endAdornment={
             <InputAdornment position="end">
               <IconButton
                 aria-label="toggle password visibility"
                 onClick={handleClickShowPasswordR1}
                 onMouseDown={handleMouseDownPassword}
                 edge="end"
                 sx={{ color: style.color1 }}
               >
                 {showRegisterPassword1 ? <VisibilityOff /> : <Visibility />}
               </IconButton>
             </InputAdornment>
           }
           label="Password"
         />

        </FormControl>


        <FormControl sx={{
         backgroundColor: style.color2,
         flex: 1,
         width:'100%',
         size: 'small',
         margin: 'auto',
         boxShadow:10,
         mt:3,

         '& .MuiInputBase-input': {
           color: style.color3,
           fontSize: '14pt',
           size: 'small',
         },
         '& .MuiOutlinedInput-root': {
           '& fieldset': {
             borderColor: style.color1,
             borderWidth: '2px'
           },
           '&:hover fieldset': {
             borderColor: style.color2,
             borderWidth: '3px',
           },
           '&.Mui-focused fieldset': {
             borderColor: style.color2,
             borderWidth: '3px',
           },
           '&.Mui-disabled': {
             '& fieldset': {
               borderColor: style.color1,
             },
           },
         },
         '& .MuiInputLabel-root': {
           color: style.color3,
           fontSize: '14pt',
         },
         '& .MuiInputLabel-root.Mui-focused': {
           color: style.color3,
         },
         '& .MuiInputLabel-root.Mui-disabled': {
           color: style.color3,
         },
         '& .MuiInputBase-root.Mui-disabled': {
           '& input': {
             color: style.color3,
             WebkitTextFillColor: style.color1,
             fontSize: '14pt'
           },
         },
         '& .MuiOutlinedInput-input': {
           color: style.color4,
           '& input:-webkit-autofill': {
           WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
           WebkitTextFillColor: `${style.color4} !important`,
           color: `${style.color4} !important`,
           caretColor: `${style.color4} !important`,
       },
         },
       }} variant="outlined">
         <InputLabel size="small" htmlFor="outlined-adornment-password2">Password</InputLabel>
         <OutlinedInput
           id="outlined-adornment-password2"
           type={showRegisterPassword2 ? 'text' : 'password'}
           value={data.registerPassword2}
           size='small'
           onChange={(e) => setData({...data, registerPassword2: e.target.value})}
           sx={{
               '& input:-webkit-autofill': {
               WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
               WebkitTextFillColor: `${style.color4} !important`,
               color: `${style.color4} !important`,
               caretColor: `${style.color4} !important`,
               
           },
           }}
           endAdornment={
             <InputAdornment position="end">
               <IconButton
                 aria-label="toggle password visibility"
                 onClick={handleClickShowPasswordR2}
                 onMouseDown={handleMouseDownPassword}
                 edge="end"
                 sx={{ color: style.color1 }}
               >
                 {showRegisterPassword2 ? <VisibilityOff /> : <Visibility />}
               </IconButton>
             </InputAdornment>
           }
           label="Password"
         />

        </FormControl>


        <Button onClick={registerUser}  sx={{ color: style.color4, display: 'block', backgroundColor: style.color1, filter: 'brightness(1.1)', boxShadow:10,fontSize: '14pt', width: '75%', minWidth: '250px', margin: 'auto', mt:7, mb:4, borderColor: style.color2, borderWidth: '1px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color2 }, }}>Register</Button>
        <Typography sx={{ mb: 1, fontSize:'1em', color:style.color4 }}>Already have an account?</Typography>
        <Button onClick={switchToLoginScreen}  sx={{textTransform: 'none', color: style.color4, display: 'block', backgroundColor: style.color1,fontSize: '14pt', width: '75%', minWidth: '250px', margin: 'auto', mb:1, borderColor: style.color1, borderWidth: '1px', borderStyle: 'solid', '&:hover': {borderColor: style.color2, backgroundColor: style.color1, boxShadow:10 }, }}>Login</Button>

        <Button onClick={closeFunction}  sx={{textTransform:'none', color: style.color4, display: 'block', backgroundColor: style.color1, fontSize: '14pt', width: '75%', minWidth: '100px', margin: 'auto', mb:1, borderColor: style.color1, borderWidth: '1px', borderStyle: 'solid', '&:hover': {borderColor: style.color2, backgroundColor: style.color1, boxShadow:10 }, }}>Back</Button>






   </Box>


       )}





















       {loginScreenVisible && (

         <Box sx={{ textAlign: "center" }}>
            <Typography sx={{ mb: 6, fontSize:'2em', color:style.color4 }}>Login to your account</Typography>
            <TextField
                id="outlined-basic"
                label="Email"
                variant="outlined"
                value= {data.email}
                onChange={(e) => setData({...data, email: e.target.value})}
                size='small'
                fullWidth
                sx={{
                    backgroundColor: style.color2,
                    borderRadius:'4px',
                    '& .MuiInputBase-input': {
                    color: style.color4,  // Change the font color here
                    fontSize: '16pt',  // Change the font size here
                    boxShadow:10,
                                                    
                    },
                    '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: style.color1, // Change the border color if needed
                        borderWidth:'2px'
                    },
                    '&:hover fieldset': {
                        borderColor: style.color1, // Change the border color on hover if needed\
                        borderWidth:'3px',                                                               
                 
                        
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: style.color1, // Change the border color when focused if needed
                        borderWidth:'3px'
                        
                    },
                    '&.Mui-disabled': {
                        '& fieldset': {
                        borderColor: style.color1, // Change the border color when disabled
                        },
                    },
                    },
                    '& .MuiInputLabel-root': {
                    color: style.color3, // Change the label color here
                    fontSize:'14pt',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                    color: style.color3, // Change the label color when focused here                                 
                    },
                    '& .MuiInputLabel-root.Mui-disabled': {
                    color: style.color2, // Change the label color when disabled
                    },
                    '& .MuiInputBase-root.Mui-disabled': {
                    '& input': {
                        color: style.color3, // Change the input font color when disabled // so it works in safari
                        WebkitTextFillColor: style.color4, // so it works on chrome
                        fontSize:'14pt'
                    },
                    },
                    '& .MuiOutlinedInput-input': { color: style.color4,
                    '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset',
                        WebkitTextFillColor: style.color4, color:style.color4
                     }, }, 
                }}
                />



<FormControl sx={{
                  backgroundColor: style.color2,
                  flex: 1,
                  width:'100%',
                  size: 'small',
                  margin: 'auto',
                  boxShadow:10,
                  mt:3,

                  '& .MuiInputBase-input': {
                    color: style.color3,
                    fontSize: '14pt',
                    size: 'small',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: style.color1,
                      borderWidth: '2px'
                    },
                    '&:hover fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-disabled': {
                      '& fieldset': {
                        borderColor: style.color1,
                      },
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: style.color3,
                    fontSize: '14pt',
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: style.color3,
                  },
                  '& .MuiInputLabel-root.Mui-disabled': {
                    color: style.color3,
                  },
                  '& .MuiInputBase-root.Mui-disabled': {
                    '& input': {
                      color: style.color3,
                      WebkitTextFillColor: style.color1,
                      fontSize: '14pt'
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    color: style.color4,
                    '& input:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                    WebkitTextFillColor: `${style.color4} !important`,
                    color: `${style.color4} !important`,
                    caretColor: `${style.color4} !important`,
                },
                  },
                }} variant="outlined">
                  <InputLabel size="small" htmlFor="outlined-adornment-password">Password</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    value={data.password}
                    size='small'
                    onChange={(e) => setData({...data, password: e.target.value})}
                    sx={{
                        '& input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                        WebkitTextFillColor: `${style.color4} !important`,
                        color: `${style.color4} !important`,
                        caretColor: `${style.color4} !important`,
                        
                    },
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          sx={{ color: style.color1 }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
  
                 </FormControl>


                 <Button onClick={loginUser}  sx={{ color: style.color4, display: 'block', backgroundColor: style.color1, filter: 'brightness(1.1)', boxShadow:10,fontSize: '14pt', width: '60%', minWidth: '250px', margin: 'auto', mt:7, mb:4, borderColor: style.color2, borderWidth: '1px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color2 }, }}>Login</Button>
                 <Typography sx={{ mb: 1, fontSize:'1em', color:style.color4 }}>Not yet a member?</Typography>
                 <Button onClick={switchToRegisterScreen}  sx={{textTransform: 'none', color: style.color4, display: 'block', backgroundColor: style.color1,fontSize: '14pt', width: '60%', minWidth: '250px', margin: 'auto', mb:1, borderColor: style.color1, borderWidth: '1px', borderStyle: 'solid', '&:hover': {backgroundColor: style.color1, borderColor: style.color1, filter:'brightness(1.1)', boxShadow:10 }, }}>Register for a Free Account</Button>

                 <Button onClick={closeFunction}  sx={{textTransform:'none', color: style.color4, display: 'block', backgroundColor: style.color1, fontSize: '14pt', width: '60%', minWidth: '100px', margin: 'auto', mb:1, borderColor: style.color1, borderWidth: '1px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color1, borderColor: style.color1, filter:'brightness(1.1)', boxShadow:10 }, }}>Back</Button>






            </Box>


                )}
         
        
      </DialogContent>
    </Dialog>
  );
};

export default LoginRegisterModal;
